<template>
    <section class="tw:border-b tw:border-zinc-200">
        <div class="tw:mx-auto tw:grid tw:max-w-7xl tw:gap-6 tw:p-4 tw:py-10 tw:md:grid-cols-3 tw:md:items-center">
            <slot />
        </div>
    </section>
</template>